import { useLoadingState } from '@ds-mgnl/marketing';
import type { FamilyAssetMap } from '../services/productApi';
import { getFamilyAssetMap } from '../services/productApi';

interface FamilyAssetMapState {
	map: FamilyAssetMap | null;
	isLoading: boolean;
	error: string | null;
}

export function useFamilyAssetMap(
	familyId: string | undefined,
): FamilyAssetMapState {
	const { data, pending, rejected } = useLoadingState<FamilyAssetMap | null>(
		() => (familyId ? getFamilyAssetMap(familyId) : Promise.resolve(null)),
		[familyId],
	);

	return {
		map: data,
		isLoading: pending,
		error: rejected ? 'Failed to load family asset map' : null,
	};
}
